import { render, staticRenderFns } from "./slider-widget.vue?vue&type=template&id=f4c94cda&"
import script from "./slider-widget.vue?vue&type=script&lang=ts&"
export * from "./slider-widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports